import { render } from "./JobAd.vue?vue&type=template&id=5278bb1a&scoped=true"
import script from "./JobAd.vue?vue&type=script&lang=js"
export * from "./JobAd.vue?vue&type=script&lang=js"

import "./JobAd.vue?vue&type=style&index=0&id=5278bb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5278bb1a"]])

export default __exports__